import { createConsumer } from "@rails/actioncable";
import BaseController from "confinus_ui/base_controller";
import { MessageNotificationData } from "lib/types";

export default class NotificationsController extends BaseController {
  public static targets = ["count"];

  declare private readonly countTarget: HTMLDivElement;
  private cableConsumer: any;

  public connect() {
    super.connect();
    this.cableConsumer = createConsumer();

    this.cableConsumer.subscriptions.create(
      {
        channel: "NotificationsChannel",
      },

      {
        received: (data: MessageNotificationData) => {
          this.handleNewMessage(data);
        },

        connected: () => {
          return;
        },
        disconnected: () => {
          return;
        },
      },
    );

    this.cableConsumer.connect();
  }

  public disconnect() {
    this.cableConsumer.disconnect();
    super.disconnect();
  }

  public incrementCounter() {
    this.element.classList.add("has-unread-messages");
    const countContent = this.countTarget.innerText;
    const currentCount =
      countContent.length === 0 ? 0 : parseInt(countContent, 10);
    this.countTarget.innerText = (currentCount + 1).toString();
  }

  public handleNewMessage(data: MessageNotificationData) {
    this.incrementCounter();
  }
}
